import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { colors } from '@naf-simba/theme';

export const Loader = () => <Spinner />;

const spin = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;

const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid;
  border-radius: 50%;
  border-color: ${colors.secondary[500]} ${colors.secondary[50]} ${colors.secondary[50]};
  animation: ${spin} 0.6s linear infinite;
`;

export default Loader;
